import { Chip } from "@mui/material";
import {
  AutocompleteArrayInput,
  FunctionField,
  Link,
  ReferenceArrayField,
  ReferenceArrayInput,
  SingleFieldList,
} from "react-admin";

const PromotionCodeFilter = (searchText: string) => {
  if (!searchText) return {};
  if (searchText.startsWith("promo_")) {
    return {
      stripe_promotion_code_id__icontains: `${searchText}`,
    };
  }
  return {
    coupon_code__icontains: `${searchText}`,
  };
};

const currencyToSymbol = (currency: string) => {
  currency = currency.toUpperCase();
  switch (currency) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "GBP":
      return "£";
    default:
      return currency;
  }
};

export const PromotionCodeArrayField = () => {
  return (
    <ReferenceArrayField label="Promotion Codes" source="promotionCodeIds" reference="promotionCode">
      <SingleFieldList>
        <FunctionField
          render={(record: any) => (
            <Chip
              sx={{ color: "#1976d2" }}
              label={
                <>
                  <span style={{ fontFamily: "monospace" }}>
                    {record.couponCode} - {""}
                    {record.percentage
                      ? `${record.percentage}%`
                      : `${currencyToSymbol(record.currency)}${record.value}`}
                  </span>{" "}
                  &nbsp;
                  <Link to={`/promotionCode/${record.id}/edit`}></Link>
                </>
              }
            />
          )}
        />
      </SingleFieldList>
    </ReferenceArrayField>
  );
};

export const PromotionCodeArrayInputField = ({ source = "promotionCodeIds", disabled = false, required = false }) => {
  return (
    <ReferenceArrayInput
      label="Promotion Codes"
      source={source}
      reference="promotionCode"
      enableGetChoices={({ q }) => q && q.length >= 2}
      disabled={disabled}
      sx={{ width: "100%" }}
      isRequired={required}
    >
      <AutocompleteArrayInput
        label="Promotion Codes"
        helperText="Lookup Promotion Codes by coupon code or stripe ID"
        optionText={(option) => {
          return (
            <>
              <span style={{ fontFamily: "monospace" }}>
                {option.couponCode} - {""}
                {option.percentage ? `${option.percentage}%` : `${currencyToSymbol(option.currency)}${option.value}`}
              </span>{" "}
              &nbsp;
              <Link to={`/promotionCode/${option.id}/edit`} target="_blank">
                ↗
              </Link>
            </>
          );
        }}
        filterToQuery={PromotionCodeFilter}
        sx={{ width: "100%" }}
      />
    </ReferenceArrayInput>
  );
};
